module.exports = __webpack_public_path__ + "static/media/Bonus.76e6be41.png";